import React from 'react'

function XIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.6689 0.958984L14.2529 10.4102L13.9824 10.7139L14.2256 11.041L23.0049 22.8486H17.1533L11.1113 14.8232L10.7461 14.3379L10.3398 14.79L2.92383 23.0508H2.34863L10.1465 14.2539L10.415 13.9512L10.1758 13.626L0.988281 1.14746H6.84668L13.2578 9.77148L13.6211 10.2598L14.0303 9.80859L22.0439 0.948242L22.6689 0.958984ZM2.2793 2.25L17.2773 22.3105L17.4277 22.5117H22.3545L21.7607 21.7129L6.83008 1.65234L6.67969 1.45117H1.68164L2.2793 2.25Z"
        fill="black"
        stroke="rgba(57, 61, 99, 1)"
      />
    </svg>
  )
}

export default XIcon
